import { render, staticRenderFns } from "./ListCustomFields.vue?vue&type=template&id=4b5fd5c5"
import script from "./ListCustomFields.vue?vue&type=script&lang=js"
export * from "./ListCustomFields.vue?vue&type=script&lang=js"
import style0 from "./ListCustomFields.vue?vue&type=style&index=0&id=4b5fd5c5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5fd5c5')) {
      api.createRecord('4b5fd5c5', component.options)
    } else {
      api.reload('4b5fd5c5', component.options)
    }
    module.hot.accept("./ListCustomFields.vue?vue&type=template&id=4b5fd5c5", function () {
      api.rerender('4b5fd5c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/customFields/ListCustomFields.vue"
export default component.exports